<template>
<div
  class="feet"
  :class="{
    'facing-right': facing === 'right'  
  }"
>
  <div class="feet__left"></div>
  <div class="feet__right"></div>
</div>
</template>

<script>
export default {
  name: 'feet',
  props: {
    facing: String
  }
}
</script>

<style lang="scss">
@keyframes feet-stomping {
  0% {
    transform: translate3d(0,0%,0);
  }
  70% {
    transform: translate3d(0,-30%,0);
  }
  100% {
    transform: translate3d(0,0%,0);
  }
}
.feet {
  position: relative;
  width: fluid(148px);
  height: fluid(102px);
  &__left {
    z-index: 1;
    position: absolute;
    bottom: 0;
    right: 0;
    width: fluid(114px);
    height: fluid(102px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/foot-left-facing-left.svg');
  }
  &__right {
    position: absolute;
    top: 0;
    left: 0;
    width: fluid(112px);
    height: fluid(85px);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    background-image: url('~@/assets/img/foot-right-facing-left.svg');
  }
  &.facing-right {
    .feet__left {
      z-index: auto;
      bottom: auto;
      top: 0;
      right: 0;
      width: fluid(112px);
      height: fluid(85px);
      background-image: url('~@/assets/img/foot-left-facing-right.svg');
    }
    .feet__right {
      z-index: 1;
      top: auto;
      bottom: 0;
      left: 0;
      width: fluid(114px);
      height: fluid(102px);
      background-image: url('~@/assets/img/foot-right-facing-right.svg');
    }
  }
}
.feet-stomping {
  .feet__left {
    animation: feet-stomping 0.75s linear infinite;
  }
  .facing-right {
    .feet__left {
      animation: none;
    }
    .feet__right {
      animation: feet-stomping 0.75s linear infinite;
    }
  }
}
</style>